import styles from './TextButton.module.scss'

export interface TextButtonProps {
	title: string;
	onClick: () => void;
}

export const TextButton = (props: TextButtonProps) => {
	return (
		<button className={styles.button} onClick={props.onClick}>
			{ props.title }
		</button>
	)
}

